export const knallisounds: string[][] = [
["alastontunti.mp3", "Alastontunti"],
["aijai.mp3", "Aijai"],
["apuvirtaa.mp3", "Apuvirtaa"],
["aviomies_kateissa.mp3", "Aviomies"],
["bbc_-_raatimiehet.mp3", "BBC - Raatimiehet"],
["bbc-piirityslahetys.mp3", "BBC - Piirityslähetys"],
["bbc-politiikkalahetys.mp3", "BBC-Politiikkalähetys"],
["gaalailta.mp3", "Gaalailta"],
["hinku_avaruuteen.mp3", "Hinku Avaruuteen"],
["ilmapallopurjehdus.mp3", "Ilmapallopurjehdus"],
["isoaidin_soppakulho.mp3", "Isoäidin soppakulho"],
["isa_on_kova_mies.mp3", "Isä on kova mies"],
["jalkiruoka.mp3", "Jälkiruoka"],
["kaasuliesi.mp3", "Kaasuliesi"],
["kersantti.mp3", "Kersantti"],
["kirjasto.mp3", "Kirjasto"],
["kotimainen_juoma.mp3", "Kotimainen juoma"],
["karsa_suppuun!.mp3", "Kärsä suppuun!"],
["laakekonjakki.mp3", "Lääkekonjakki"],
["mainostoimisto.mp3", "Mainostoimisto"],
["minipoksyt.mp3", "Minipöksyt.mp3"],
["mrs_bratby.mp3", "Mrs. Bratby"],
["naispuolinen_nainen.mp3", "Naispuolinen nainen"],
["nakupimu.mp3", "Nakupimu"],
["nuori_hirvi.mp3", "Nuori Hirvi"],
["osuma.mp3", "Osuma"],
["osuma2.mp3", "Osuma II"],
["ovikello.mp3", "Ovikello"],
["paahtoleipa.mp3", "Paahtoleipä"],
["pizzan_kalteva_torni.mp3", "Pizzan kalteva torni"],
["putkimies.mp3", "Putkimies"],
["pullat.mp3", "Pullat"],
["pystyyn.mp3", "Pystyyn"],
["rouva_pitkin.mp3", "Rouva Pitkin"],
["saksan_kuoro.mp3", "Saksan kuoro"],
["sir_henry_-_kaapapaastaiset.mp3", "Kääpäpäästaiset"],
["sir_henry_-_lasisilma.mp3", "Lasisilmä"],
["sir_henry_-_sika.mp3", "Sika "],
["sir_henry_-_vaimo.mp3", "Vaimo "],
["sir_henry_-_vaimo_ii.mp3", "Vaimo II"],
["sir_henry-hiekanjyvat.mp3", "Hiekanjyvät"],
["sir_henry-kasi_lipeaa.mp3 ", "Käsi lipeää"],
["sir_henry-mita.mp3", "Mitä"],
["sir_henry-sihteeri_lomalla.mp3", "Sihteeri lomalla"],
["sir_henry-strippiluola.mp3", "Strippiluola"],
["sir_henry-te_olette_epasympaattinen.mp3", "Te olette epäsympaattinen"],
["sir_henry-tyttoja.mp3", "Sir Henry - Tyttöjä "],
["sir_henry-vuosisadasta_toiseen.mp3", "Sir Henry - Vuosisadasta toiseen "],
["sonni.mp3", "Sonni"],
["stressi_ei_sovi_nuorelle_tytolle.mp3", "Stressi ei sovi nuorelle tytölle"],
["surkea_ja_veltto.mp3", "Surkea ja veltto"],
["valeraparperi.mp3", "Valeraparperi"],
["vauva_halajaa.mp3", "Vauva halajaa"],
["viskisammio.mp3", "Viskisammio"],
["ooaa.mp3", "Ööää"] 
];